import type { FaireProductEntity } from "../../entity_types/product";

export const p_n9mfa3cuu4: FaireProductEntity = {
  token: "p_n9mfa3cuu4",
  type: "product",
  name: "Rosemary & Mint Shampoo Bar: Nourishing & Cleansing",
  brandToken: "b_a845a903",
  brandName: "Spinster Sisters Co. / Old Salt Grooming Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/dede90947e182482af9f9d0cf44edf26c9124001b9dab576aba58e067a61c871.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cbddf41511d9e8f21313bfcd591f33eda4f23e1963552624c95cdb56ac4ff85b.png",
    "https://cdn.faire.com/fastly/2acf9ed8412d9e37d59e1b4502f0d50c6fb719658a98281f0aa8c958cb262a69.png",
    "https://cdn.faire.com/fastly/bd412cdfb11fef5241888f6d12cb07fbd4655d50fb4851649e637b4a0ce212a3.png",
    "https://cdn.faire.com/fastly/0b2cf01e33ee2d9ce1a1616f8a9005b8a8eee16de10af4edf3fd55f197695336.png",
    "https://cdn.faire.com/fastly/5ce4201c6c86122353d80a9745929f868ba610841921b3be513afbdc4360ea46.png",
    "https://cdn.faire.com/fastly/6ec5a2d72e55545b1d1c6f1665c623855c058cf60d395049bbe9a2d3ee3ecee2.png",
  ],
  priceDollars: 8.99,
  description:
    "Rosemary & Mint Shampoo Bar is a sulfate-free option designed for nourishing and cleansing hair. This luxurious bar blends olive, coconut, castor, and jojoba oils, known for promoting healthy hair growth while providing essential moisture to the scalp.\n\n* Infused with invigorating rosemary and mint essential oils for a refreshing aroma\n* pH balanced formula ensures gentle cleansing and hydration\n* Eco-friendly design supports a plastic-free, sustainable beauty routine\n* Cruelty-free ingredients align with ethical skincare values\n* Suitable for Type 1 (straight) and Type 2 (wavy) hair for versatile use\n\nAn ideal addition to any retailer’s eco-conscious hair care line, this shampoo bar appeals to customers seeking a plant-based, effective solution that delivers shine, smoothness, and a refreshing wash. \n\nTravel, Summer, Father's Day, Beach, Swimming",
  tags: [],
  msrpDollars: 17.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:24.626Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
